import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { getFunctions, addFunctionToNode } from "actions/workflows";
import Select from "components/Elements/Select";

const AddFunctionToNodeModal = NiceModal.create(() => {
  const dispatch = useDispatch();
  const modal = useModal();
  const functions = useSelector((state) => state.workflows.functions);
  const [localFunction, setLocalFunction] = useState({});
  const [functionOptions, setFunctionOptions] = useState([]);
  const [functionsByName, setFunctionsByName] = useState({});

  useEffect(() => {
    if (functions.length === 0) {
      dispatch(getFunctions());
    }
    return () => {
      window.document.body.classList.remove("overflow-hidden");
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const options = functions.map((f) => {
      return f.name;
    });

    setFunctionOptions(["New Function", ...options]);

    const byName = {};
    functions.forEach((f) => {
      byName[f.name] = f;
    });
    setFunctionsByName(byName);
  }, [functions]);

  const hide = (e) => {
    e.stopPropagation();
    modal.remove();
  };

  const handleChange = (funct_name) => {
    setLocalFunction(funct_name);
  };

  useEffect(() => {}, [localFunction]);

  const handleAddFunctionToNode = () => {
    if (localFunction === "New Function") {
      NiceModal.show("add-function", {}).then((funct) => {
        dispatch(addFunctionToNode(funct));
        modal.remove();
      });
    } else {
      const f = functionsByName[localFunction];
      dispatch(addFunctionToNode(f));
      modal.remove();
    }
  };

  return (
    <>
      <div className="w-6/12 force-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">Add Function to Node</h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative p-6 flex-auto ">
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <Select
                  label="Function"
                  name="function"
                  value={localFunction}
                  onChange={handleChange}
                  items={functionOptions}
                />
              </div>
            </div>

            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button
                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={hide}
              >
                Close
              </button>
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={handleAddFunctionToNode}
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

export default AddFunctionToNodeModal;
